import { ComboRow, IUpload } from './coremodels';

export const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

export const json = (json: any): any => {
  const sd = json.sd || json.result?.sd || json.data?.sd || json;
  return sd || {};
};

export const rows = (json: any): any[] => {
  const sd = json.sd || json.result?.sd || json.data?.sd || json;
  return Array.isArray(sd) ? sd : [];
};

export const normalizeCombo = (r: any) => ({
  rid: r.rid ?? r.recid ?? r.id,
  shc: r.shc ?? r.shortcode ?? r.code ?? r.nam ?? r.recname ?? '',
  nam: r.nam ?? r.recname ?? r.name ?? r.shc ?? r.shortcode ?? '',
  raw: r,
});

export const fetchCombo = async (service: string, params?: any) =>
  rows(await postBiz({ s: service, a: 'combo', ...(params || {}) })).map(normalizeCombo);

// private postBiz = async (payload: any) => {
//     const res = await fetch('/biz', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       credentials: 'include',
//       body: JSON.stringify(payload),
//     });

//     const json = await res.json();

//     if (!res.ok || json.failure) {
//       throw new Error(json.em || json.message || 'Request failed');
//     }

//     return json;
//   };

//   private jsonRows = (json: any): ComboRow[] => {
//     const sd = json.sd || json.result?.sd || json.data?.sd || json;
//     return Array.isArray(sd) ? sd : [];
//   };

//   private fetchCombo = async (service: string): Promise<ComboRow[]> => {
//     const json = await this.postBiz({ s: service, a: 'combo' });
//     return this.jsonRows(json);
//   };


//
export const uploadBiz = async ({
  prefix,
  service,
  action,
  file,
  params = {},
}: IUpload) => {
  const formData: any = new FormData();

  formData.append('file', file, file.name);
  formData.append('s', service);
  formData.append('a', action);
  formData.append('prefix', prefix);
  formData.append('filename', file.name);

  Object.keys(params || {}).forEach((key) => {
    const val = params[key];

    if (val === undefined || val === null) {
      formData.append(key, '');
    } else if (typeof val === 'object') {
      formData.append(key, JSON.stringify(val));
    } else {
      formData.append(key, String(val));
    }
  });

  const config: any = {
    method: 'POST',
    credentials: 'include',
    headers: new Headers(),
    body: formData._blob ? formData._blob() : formData,
  };

  const resp = await fetch(`/biz/file/${prefix}`, config);
  const response = await resp.json();

  if (response.success) return response;

  if (response.failure) {
    return Promise.reject({
      name: 'fetcherror',
      title: response.et || 'Upload Error',
      message: response.em || 'Upload failed',
      data: response,
    });
  }

  return Promise.reject({
    name: 'fetcherror',
    title: 'Upload Error',
    message: 'Upload failed',
    data: response,
  });
};